import router from '@/router';
import axios from 'axios';

export default {
    namespaced: true,
    state: {

        historyClient: null,
        dataDomain: null,
        serviceClient: null,

    },

    getters: {
        //AUTH
        isAuthenticated(state) {
            return state.isAuthenticated;
        },
        serviceClient(state){
            return state.serviceClient;
        },
        dataDomain(state){
            return state.dataDomain;

        }
    },

    mutations: {

        // AUTH
        isAuthenticated(state, payload) {
            state.isAuthenticated = payload.isAuthenticated;
        },
        serviceClient(state, payload) {
          try {
            const cleanedResponseData = payload.replace(/string\(\d+\)\s/g, '').trim();
            const responses = cleanedResponseData.trim().split('\n');
            const validResponses = [];
    
            responses.forEach((response, index) => {
              try {
                const parsedResponse = JSON.parse(response);
                validResponses.push(parsedResponse);
              } catch (error) {
                // console.error(`Error parsing response ${index + 1}:`, error);
              }
            });
            state.serviceClient = validResponses[0];
            
          } catch (error) {
            state.serviceClient = payload;
            
          }
    
        },
        dataDomain(state, payload) {
            let dataDomain = {
                domain_general: payload[0],
                domain_propiedades: payload[1],
                domain_mx: payload[4]

            }
            console.log("dataDomain: ", dataDomain.domain_general);
            dataDomain.domain_propiedades = {...dataDomain.domain_propiedades, ...payload[2], ...payload[3]};
            if(!dataDomain.domain_general || dataDomain.domain_general['Servidor de nombre'] == ''){
              dataDomain.error = true;
            }else{
              dataDomain.error = false;

            }
            state.dataDomain = dataDomain;
        },

    },

    actions: {
        async getServiceClient(context, payload){
          try {
              let url = process.env.VUE_APP_API_BASE_URL + '/api/ticketsTable/VerDetalleHabilitacion';
              let res = await axios.post(url, {id:payload.id});

              if(res.status == 200){
                context.commit('serviceClient', res.data);
                return true;
              }else{
                console.log("error getServiceClient: ", res);
                return false;
              }
          } catch (error) {
            console.error('getServiceClient error:', error.message ?? error);
            return false;
          }
        },

        async getDomain_ServiceClient(context, payload){
          try {
            let url_domain = process.env.VUE_APP_IH_API_DOMAIN_URL + "/" + payload.domain;
            let res_domain = await axios.get(url_domain);
            if(res_domain.status == 200){
              context.commit('dataDomain', res_domain.data);
              return true;
            }else{
              console.log("error getDomain_ServiceClient: ", res_domain);
              return false;
            }
          } catch (error) {
            console.error('getDomain_ServiceClient error:', error.message ?? error);
            return false;
          }
        },



     
    }
}
